import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29738e50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column align-items-center camera-begging-container" }
const _hoisted_2 = { class: "d-flex flex-column camera-begging-content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h3 data-v-29738e50>You&#39;ll be asked to enable camera access</h3><ul data-v-29738e50><li data-v-29738e50> Camera access is the <strong data-v-29738e50>ONLY</strong> way you can scan our QR codes on trailers. </li><li data-v-29738e50> Trailer GPS can lag behind. Scanning the QR code quickly verifies you&#39;re attaching to the right trailer. </li><li data-v-29738e50> While camera access is <strong data-v-29738e50>OPTIONAL</strong>, it provides you with much faster attachments. </li><li data-v-29738e50> Your camera is <strong data-v-29738e50>ONLY</strong> used while taking a picture of, or scanning a trailer. </li></ul>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgCamera = _resolveComponent("SvgCamera")!
  const _component_FbxButton = _resolveComponent("FbxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_SvgCamera, { color: "#545454" }),
        _hoisted_3
      ]),
      _createVNode(_component_FbxButton, {
        buttonText: _ctx.buttonText,
        disabled: _ctx.isContinueDisabled,
        showLoading: _ctx.isContinueDisabled,
        onClicked: _ctx.onContinue
      }, null, 8, ["buttonText", "disabled", "showLoading", "onClicked"])
    ])
  ]))
}